import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ScreenCreatorTransactionService } from "src/app/shared/services/screen-creator-transaction.service";

export interface FormData {
  screenName: any
}

@Component({
    selector: 'app-transaction-screen-creator-message',
    templateUrl: './transaction-screen-creator-message.component.html',
    styleUrls: ['./transaction-screen-creator-message.component.scss'],
    standalone: false
})
export class TransactionScreenCreatorMessageComponent implements OnInit {

  screenName = "";

  constructor(private dialogref: MatDialogRef<TransactionScreenCreatorMessageComponent>, @Inject(MAT_DIALOG_DATA) public data: FormData, private service: ScreenCreatorTransactionService) { }

  ngOnInit() {

    this.screenName = this.data.screenName;

    console.log(this.screenName);

  }

  async yes() {

    console.log("yes");

    await this.service.deleteTableService(this.screenName);

    await this.dialogref.close();

  }

  no() {

    console.log("no");

    this.dialogref.close();

  }

}